import { react } from 'react';
import moment from 'moment';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const  validity = (args,coursedetails) => {
    let course_validity
    // args = "1";
    switch (args) {
      case "0":
        course_validity = 'Unlimited Validity';
        break;
      case "1":
        course_validity = coursedetails?.course.cb_validity > 1 ? coursedetails?.course.cb_validity + ' Days' : coursedetails?.course.cb_validity + ' Day';
        course_validity = "Expiring on:"+course_validity 
        // echo daysToMonth($course['cb_validity']);
        break;
      case "2":
        // console.log(selectedUTCOffset,"selectedUTCOffset")
        //convertUTCDateToLocalDate(coursedetails?.course.cb_validity_date)
        // course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' : current_date_format(1, convert_to_user_time($course['cb_validity_date']), 2);
        // course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' : coursedetails?.course.cb_validity_date
        //  course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' :  
        //  new Date(new Date(coursedetails?.course.cb_validity_date).getTime() + selectedUTCOffset);
        course_validity = coursedetails?.course.cb_validity_date;
        course_validity = moment(course_validity).format('DD-MM-YYYY');

       // return coursedetails?.course.cb_validity_date;
        course_validity = "Expiring on:"+course_validity
        break;
      default:
        // course_validity = 'Lifetime';
        break;
    }
    return course_validity
}


